import M from 'materialize-css';
import { getAuthService } from './authWrapper';


export default (to, from, next) => {
  const authService = getAuthService();

  const fn = () => {
    if (!to.meta.requiresLogin) {
      return next();
    }
    if (!authService.isAuthenticated) {
      authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
    }

    if (authService.hasRoles('lockdown')) {
      M.toast({
        html: 'Account has been temporarily disabled while we set your roles, after which your access will be reinstated. Please contact #investing-tech-help.',
        classes: 'pink',
      });
      return next(false);
    }
    let unAuthorizedResult = false;
    if (to.meta.redirectOnUnauthorized) {
      unAuthorizedResult = to.meta.redirectOnUnauthorized;
    }
    if (to.meta.excludedRoles) {
      const { excludedRoles } = to.meta;
      const hasExcludedRole = authService.hasRoles(...excludedRoles);
      if (hasExcludedRole) {
        M.toast({
          html: 'Access denied based on your role.',
          classes: 'pink',
        });
        return next(unAuthorizedResult);
      }
    }
    if (to.meta.requiredRoles) {
      const { requiredRoles } = to.meta;
      const hasRoles = authService.hasRoles(...requiredRoles);
      if (!hasRoles) {
        M.toast({
          html: 'Access denied, please contact #investing-tech-help for permissions',
          classes: 'pink',
        });
        return next(unAuthorizedResult);
      }
    }
    return next();
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn();
    }
  });
};
